module.exports = __webpack_public_path__ + "static/media/lattice-logo-2019-newText-lightBackground.94c0ebb5.svg";